import { Component, Input, ViewChild } from '@angular/core';
import { filterPageTypes, FilterType } from 'src/app/store/filters.era';
import { PAGE_NAME } from 'src/app/services/event.permissions.service';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { pageGroupHandles, PageHandle } from 'globals/store/permissions.data';
import { TasksTableComponent} from 'src/app/components/home/tasks-table.component';
import { Wrapper } from '../../components/wrapper.component';
import { importSheet } from '../performers/performerSharedFunctions';
import { FuzzyImportDialogComponent, FuzzyImportDialogData } from '../../components/wizards/fuzzy-import.dialog.component';
import { Task } from 'globals/store/tasks.data';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { CommonModule, DatePipe } from '@angular/common';
import { TasksCommandMenu } from 'src/app/components/home/tasks-command-menu.component';
import { TopMenuComponent } from '../program/top.menu';
import { MobileMenuComponent } from 'src/app/components/menu/mobile-menu.component';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
@Component({
    selector: 'task-table',
    template: `
<top-menu></top-menu>
<mobile-menu></mobile-menu>
<loader-pane-fragment [trace]="traceName"></loader-pane-fragment>
<tasks-command-menu 
  [filterPage]="filterPage" 
  [isTableView]="true"
  [showImport]="!isMyTasks"
  (onImport)="importTasks()"
  (saveTable)="saveTable()"
></tasks-command-menu>
<tasks-table 
  [saveType]="isMyTasks ? 'my tasks' : 'tasks'" 
  [saveName]="isMyTasks ? 'My tasks table' : 'Tasks table'" 
  [filterPage]="filterPage"
></tasks-table>
  `,
    styleUrls: ['../../page.scss'],
    standalone: true,
    providers: [DatePipe],
    imports: [CommonModule, TopMenuComponent, MobileMenuComponent, LoaderPaneFragmentComponent, TasksCommandMenu, TasksTableComponent],
})
export class TaskTableComponent extends Wrapper<TasksTableComponent> {
  @Input() isMyTasks:boolean;
  @Input() page_name: PageHandle = PAGE_NAME.task_table
  @Input() filterPage: FilterType = filterPageTypes.tasksTable
  @Input() traceName = traceNames.viewTasksTable
  groupHandles = pageGroupHandles
  @ViewChild(TasksTableComponent) taskTable:TasksTableComponent

  saveTable(){
    this.taskTable.saveTable();
  }

  async importTasks() {
    console.log("SHOULD BE IMPORTING TASKS!!!")
    const sheet = await importSheet()
    if (!sheet) return

    const data: FuzzyImportDialogData<Task> = {
      dialogTitle: 'Import tasks into the event',
      columns: [
        { id: 'name', title: 'Task Name', searchTerms: ['title', 'name', 'task'] },
        { id: 'content', title: 'Additional Task Information', searchTerms: ['about', 'summary', 'description', 'content', 'additional', 'info'] }
      ],
      sheet,
      transformers: {
        'name': (t: string) => t || '',
        'content': (d: string) => d || '',
      }
    }
    const result = await openDialogGetResult<Partial<Task>[]>(this.dialog, FuzzyImportDialogComponent, {panelClass:'full-screen-modal', data})
    if (!result) return
    console.log({ importedTasks: result })

    result.forEach(({ name, content }) => this.taskService.createAndSaveTask(name, this.eventService.eventId, null, null, content))
  }

  

}




